import { Badge, type BadgeTone } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import { Card, CardHeader } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'
import type { VenueClosureItemView, VenueClosureType } from '@/lib/venue/closureTypes'
import { closureCourtsText, closureReasonOrTitleText } from '@/lib/venue/closureViewModel'

const COLUMNS = ['일시', '유형', '대상 코트', '사유·레슨명', '해제']

/** 🚨 배지 색만 프런트가 매핑한다 — 텍스트는 서버 라벨(`typeLabel`) 그대로(`CourtCard.tsx` 규칙 승계). */
const TYPE_TONE: Record<VenueClosureType, BadgeTone> = {
  HOLIDAY: 'neutral',
  BLOCK: 'danger',
  RECURRING_BLOCK: 'danger',
  LESSON: 'warning',
}

/** 목록 표(설계 §2). */
export function ClosureListTable({
  items,
  editable,
  onDelete,
}: {
  items: VenueClosureItemView[]
  editable: boolean
  onDelete: (item: VenueClosureItemView) => void
}) {
  return (
    <Card>
      <CardHeader title="일정 목록" action={<span className="text-sm text-slateish-600">{items.length}건</span>} />

      {items.length === 0 ? (
        <EmptyState
          title="등록된 일정이 없습니다"
          description="휴무일·차단 시간·반복 차단·레슨을 추가해 보세요."
        />
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px] text-left text-sm">
            <thead>
              <tr className="border-b border-slateish-200 text-xs text-slateish-400">
                {COLUMNS.map((column) => (
                  <th key={column} scope="col" className="whitespace-nowrap px-5 py-3 font-medium">
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.closureId} className="border-b border-slateish-200 last:border-b-0">
                  <td className="px-5 py-3 text-ink-700">{item.periodLabel}</td>
                  <td className="whitespace-nowrap px-5 py-3">
                    <Badge tone={TYPE_TONE[item.type]}>{item.typeLabel}</Badge>
                  </td>
                  <td className="px-5 py-3 text-slateish-600">{closureCourtsText(item)}</td>
                  <td className="px-5 py-3 text-slateish-600">{closureReasonOrTitleText(item)}</td>
                  <td className="whitespace-nowrap px-5 py-3">
                    <Button
                      variant="secondary"
                      size="sm"
                      className="border-danger-500 text-danger-500 hover:bg-danger-100"
                      disabled={!editable}
                      onClick={() => {
                        onDelete(item)
                      }}
                    >
                      해제
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  )
}
